import requests from '../../api/client'
import { CardRegisterResponse } from '../../types/otp'

interface CardRegisterJson {
  documento: string
  nome_titular: string
  numero_cartao: string
  mes_ano_vencimento: string
  cvv: string
}

export default async function fetchCardRegister(
  cardRegisterJson: CardRegisterJson
): Promise<CardRegisterResponse | null> {
  try {
    const { retorno, mensagem, dados } = (await requests.cardRegister(
      cardRegisterJson
    )) as CardRegisterResponse
    return { retorno, mensagem, dados }
  } catch (error) {
    console.error('Erro na requisição de registro do cartão:', error)
    return null
  }
}